<template>
  <div class="features-page pattern-bg">
    <Features />
  </div>
</template>

<script>
import Features from '@/components/home/Features.vue'

export default {
  name: 'FeaturesView',
  components: {
    Features
  }
}
</script>

<style scoped>
.pattern-bg {
  background: rgba(142, 202, 230, 0.1) !important;
}

.features-page {
  position: relative;
}

/* Bordo superiore decorativo */
.features-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right,
    #219ebc, /* Azzurro medio */
    #8ecae6  /* Azzurro chiaro */
  );
}

/* Pattern di sfondo sottile */
.features-page {
  background-image: linear-gradient(45deg,
    rgba(142, 202, 230, 0.05) 25%,
    transparent 25%,
    transparent 75%,
    rgba(142, 202, 230, 0.05) 75%,
    rgba(142, 202, 230, 0.05)
  );
  background-size: 20px 20px;
}
</style>
